package ru.playa.sce.dto

data class Point(val latitude: Double, val longitude: Double)
